import { addNodeToBranch, updateNodeInBranch, addBranch } from "../../redux/Slice/Workflow/workflowSlice";
import { DEFAULT_BUSINESS_HOURS_VALUE } from "./BusinessHoursEditor";

export const BUSINESS_HOURS_BRANCH_ACTION_NAME = "Branch: Business Hours";

// Same definition the server seeds for WhatsApp (workflow.actionDefaults.js); Instagram, Facebook
// and Website drawers keep their action lists locally, so they reuse this one.
export const BUSINESS_HOURS_BRANCH_ACTION = {
  name: BUSINESS_HOURS_BRANCH_ACTION_NAME,
  description: "Splits the workflow into a YES path (current time is inside the configured business hours) and a NO path (it isn't).",
  category: "Logic",
  config: [
    {
      name: "Business Hours Node",
      required: true,
      fields: [{ label: "Configuration", type: "businessHours", selectedValue: DEFAULT_BUSINESS_HOURS_VALUE }],
    },
  ],
};

export const isBusinessHoursBranchAction = (name) => name === BUSINESS_HOURS_BRANCH_ACTION_NAME;

export const buildBusinessHoursConfig = (configValue) => [
  {
    name: "Business Hours Node",
    required: true,
    fields: [{ label: "Configuration", type: "businessHours", selectedValue: configValue }],
  },
];

/**
 * Creates (or reuses, when editing) the two label-only yes/no branches and stamps
 * next/branches/condition onto `actionWithConfig`. The executor evaluates the condition
 * synchronously and jumps straight to one of the branches, so there is no reply to match.
 */
export const applyBusinessHoursBranches = async ({ dispatch, editAction, actionWithConfig, configValue }) => {
  const currentState = window.store?.getState ? window.store.getState() : null;
  const currentBranches = currentState?.workflow?.selectedWorkflow?.currentVersion?.branches || {};

  // Reuse the existing branch key when editing so downstream nodes aren't orphaned.
  const resolveBranchId = (branchName) => editAction?.branches?.[branchName] || `option-${branchName}-${Date.now()}`;
  const yesBranchId = resolveBranchId("yes");
  const noBranchId = resolveBranchId("no");

  for (const [branchName, branchId, label] of [
    ["yes", yesBranchId, "Business hours: Yes"],
    ["no", noBranchId, "Business hours: No"],
  ]) {
    if (!currentBranches[branchId]) {
      await dispatch(addBranch({ branchId }));
    }
    const triggerNode = {
      id: `${branchId}-trigger`,
      type: "trigger",
      trigger: {
        name: label,
        description: branchName === "yes"
          ? "Runs when the current time is inside the configured business hours."
          : "Runs when the current time is outside the configured business hours.",
        triggerType: "non-root",
        config: [],
        category: "Nil",
      },
    };
    await dispatch(updateNodeInBranch({ branchId, nodeId: `${branchId}-trigger`, updates: triggerNode }));
    const stateAfterUpdate = window.store?.getState ? window.store.getState() : null;
    const branchAfterUpdate = stateAfterUpdate?.workflow?.selectedWorkflow?.currentVersion?.branches?.[branchId];
    if (!branchAfterUpdate || branchAfterUpdate.length === 0) {
      await dispatch(addNodeToBranch({ branchId, node: triggerNode }));
    }
  }

  actionWithConfig.next = [yesBranchId, noBranchId];
  actionWithConfig.branches = { yes: yesBranchId, no: noBranchId };
  actionWithConfig.condition = {
    type: "business_hours",
    timezone: configValue?.timezone || "UTC",
    schedule: configValue?.schedule || DEFAULT_BUSINESS_HOURS_VALUE.schedule,
  };
};
